
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lal-kitab",
      function () {
        return require("private-next-pages/lal-kitab.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lal-kitab"])
      });
    }
  